const OBJCODE = {
  PROJECT: 'project',
  OPTASK: 'optask',
  LOGIN: 'login',
  TASK: 'task',
  PROJECT_SEARCH: 'project/search',
  TASK_SEARCH: 'task/search',
  DOCUMENT: 'document/search',
  NOTE: 'note',
  NOTE_SEARCH: 'note/search',
  USER: 'user/search',
  TEAM: 'team/search',
  TEMPLATE: 'template/search',
  QUET_SEARCH: 'quet/search',
  CTGY_SEARCH: 'ctgy/search',
  CSTEM_SEARCH: 'cstem/search',
  ISSUE: 'issue/search',
  PORTFOLIO_SEARCH: 'portfolio/search',
  PROGRAM_SEARCH: 'program/search',
  PROJ_METADATA: 'proj/metadata',
  TASK_METADATA: 'task/metadata',
  REQUEST_QUEUES: 'PROJ/helpDeskQueues',
  DOCUMENT_UPLOAD: 'document',
  DOC_SEARCH: 'DOCFDR/search',
  DOC_CREATE: 'DOCFDR',
  CREATE_PROOF: 'docu/createProof',
};
export default OBJCODE;
